import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { student_enroll_courses_data, update_student_enroll_course } from "../../../api/Student_Enroll";

// Modal Styles
const customStyles = {
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        width: "400px",
        height: "auto",
        margin: "auto",
        padding: "20px",
        borderRadius: "10px",
        border: "none",
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.3)",
    },
};

const UpdateStudentCourse = ({ isOpen, onClose, user_id }) => {
    const { control } = useForm();
    const [selectedCourse, setSelectedCourse] = useState([]);
    const [enrollCourseList, setEnrollCourseList] = useState([]);
    const [removedCourses, setRemovedCourses] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const removedCourseIds = removedCourses.join(",");
            const data = await student_enroll_courses_data(user_id, removedCourseIds);
            setEnrollCourseList(data);
            setSelectedCourse(data);
        };

        if (user_id, isOpen) {
            fetchData();
        }
    }, [user_id, isOpen]);

    const handleCourseChange = (selectedOptions) => {
        const removed = selectedCourse
            .filter(course => !selectedOptions.some(sel => sel.value === course.value))
            .map(course => course.value);
        setRemovedCourses(prev => [...new Set([...prev, ...removed])]);
        setSelectedCourse(selectedOptions);
    };


    const handleSubmit = async () => {
        try {
            const removedCourseIds = removedCourses.join(",");
            const payload = {
                course_id: removedCourseIds,
            };
            let result = await update_student_enroll_course(payload, user_id);
            if (result.status) {
                onClose(false);
            }
        } catch (error) {
            console.error("Error in handleSubmit:", error);
        }
    };



    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => onClose(false)}
            style={customStyles}
            ariaHideApp={false}
            className="modal-content"
            overlayClassName="modal-overlay"
            contentLabel="Modal"
        >
            <div className="modal-header pt-0">
                <h1 className="modal-title fs-5">Update Student Course</h1>
                <button
                    type="button"
                    onClick={() => onClose(false)}
                    className="btn-close"
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body complete_payment_popup">
                <div className="complete_payment_popup">
                    <div className="container inline-flex">
                        <div className="row">
                            <div className={`col-md-12`}>
                                <label>Course List</label>
                                <Controller
                                    name="course"
                                    control={control}
                                    defaultValue={[]}
                                    render={({ field }) => (
                                        <Select
                                            options={selectedCourse}
                                            placeholder="Choose Course"
                                            isMulti
                                            {...field}
                                            value={selectedCourse}
                                            onChange={(selectedOptions) => {
                                                handleCourseChange(selectedOptions);
                                                field.onChange(selectedOptions);
                                            }}
                                        />
                                    )}
                                />

                            </div>
                        </div>
                    </div>
                </div>
                <button
                    onClick={handleSubmit}
                    style={{
                        width: "100%",
                        padding: "10px",
                        backgroundColor: "#007bff",
                        color: "white",
                        fontSize: "16px",
                        marginTop: "15px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Update
                </button>
                <button
                    onClick={() => onClose(false)}
                    style={{
                        width: "100%",
                        padding: "10px",
                        backgroundColor: "#ccc",
                        color: "#333",
                        fontSize: "14px",
                        marginTop: "10px",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};

export default UpdateStudentCourse;
